module.exports = __webpack_public_path__ + "img/组5255@2x.6582a55d.png";